gsap.registerPlugin(PixiPlugin, CustomEase);

function getFitContainer(elem, screen, scale = 1) {
  const ew = elem._texture ? elem._texture.width : elem.width;
  const eh = elem._texture ? elem._texture.height : elem.height;
  const e_ratio = ew / eh;
  const cw = screen.width;
  const ch = screen.height;
  const c_ratio = cw / ch;
  const ret = {
    width: 0,
    height: 0,
    x: 0,
    y: 0,
  };
  if (e_ratio >= c_ratio) {
    // 中身が横長
    // 高さをコンテナに合わせる
    ret.height = ch * scale;
    ret.width = ch * e_ratio * scale;
  } else {
    // 中身が縦長
    // 横幅をコンテナに合わせる
    ret.height = (cw / e_ratio) * scale;
    ret.width = cw * scale;
  }
  ret.x = cw * 0.5;
  ret.y = ch * 0.5;
  return ret;
}

function splitText(container) {
  const inner_text = container.textContent;
  let html = '';
  let letter_cache;
  Array.from(inner_text).forEach((letter) => {
    if (/\\/.test(letter)) {
      // デフォルト改行
      html += '<br>';
    } else if (/\|/.test(letter)) {
      // SP用改行
      html += '<br class="tbmin">';
    } else if (/\t|\s/.test(letter) && /\t|\s/.test(letter_cache)) {
      // 連続スペース
    } else if (/\t|\s/.test(letter)) {
      html += `<span class="letter space">${letter}</span>`;
    } else {
      html += `<span class="letter">${letter}</span>`;
    }
    letter_cache = letter;
  });
  // console.log(inner_text);
  container.innerHTML = html;
}

function showLetters(container, speed = 0.4, overrap = 0.3, callback) {
  const letters = container.querySelectorAll('.letter');
  if (letters) {
    let total_duration = 0;
    const start_timings = [];
    const durations = [];
    const interval = 1;

    Array.from(letters).forEach((elem) => {
      // console.log(elem.textContent);
      const _interval = /,|。/.test(elem.textContent) ? interval : 0;
      const dur = speed * 0.8 + speed * 0.2 * Math.random();
      const _overrap = Math.min(dur, overrap);
      start_timings.push(total_duration);
      durations.push(dur);
      total_duration += dur - _overrap + _interval;
    });
    // const total_duration = durations.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    const tl = gsap.timeline();
    tl.fromTo(
      letters,
      {
        opacity: 0,
        scaleX: 1.8,
        filter: 'blur(4px)',
      },
      {
        opacity: 1,
        scaleX: 1.0,
        filter: 'blur(0px)',
        duration: (idx) => {
          return durations[idx];
        },
        delay: (idx, elem, _array) => {
          return start_timings[idx];
        },
        onComplete: () => {
          if (typeof callback == 'function') {
            callback();
          }
        },
      },
      0
    );
    return total_duration;
  }
}

function hideLetters(container, _dur = 3, speed = 1.2, _delay = 0) {
  const letters = container.querySelectorAll('.letter');
  if (letters) {
    const durations = Array.from(letters).map(() => {
      return speed * 0.5 + speed * 0.5 * Math.random();
    });
    const tl = gsap.timeline();
    tl.fromTo(
      letters,
      {
        opacity: 1,
        scaleX: 1.0,
        filter: 'blur(0px)',
      },
      {
        opacity: 0,
        scaleX: 1.8,
        filter: 'blur(4px)',
        duration: (idx) => {
          return durations[idx];
        },
        delay: (idx, elem, _array) => {
          return Math.max(0, _dur * (idx / _array.length) - durations[idx]) + _delay;
        },
      },
      0
    );
  }
}

const app = new PIXI.Application();
const container = document.querySelector('#intro');
const paragraphs = document.querySelectorAll('#introText .paragraph');
const timeout_collector = [];
const timeline_collector = [];

[...paragraphs].forEach(splitText);

const intro_flag = function () {
  // SessionStorageを参照してスキップを判断??
  // # がついている場合はイントロスキップ
  if (location.hash == '') {
    return true;
  } else {
    return false;
  }
};

async function removeIntro() {
  const wrapper = document.querySelector('#introWrap');
  if (!wrapper) {
    return;
  }
  removeIntroBg();
  await gsap.to(wrapper, {
    autoAlpha: 0,
    duration: 0.8,
    onComplete: () => {
      try {
        app.destroy();
      } catch (err) {
        // console.log(err);
      }
      document.querySelector('body').classList.remove('fixed');
      killAllTimelines();
      if (wrapper != null) {
        wrapper.remove();
      }
      return true;
    },
  });
}

function killAllTimelines() {
  // 進行中のtimeoutとtimelineを全て破棄
  timeout_collector.forEach((timer_id) => {
    clearTimeout(timer_id);
  });
  timeline_collector.forEach((timeline) => {
    // console.log(timeline);
    timeline.kill();
  });
}

function skipIntro() {
  removeIntroBg();
  async function gotoTop() {
    await killAllTimelines();
    await removeIntro();
    // console.log('OWATA!');
    return true;
  }
  if (document.readyState == 'loading') {
    window.addEventListener('load', (e) => {
      gotoTop();
    });
  } else {
    gotoTop();
  }
}

function introScroll() {
  const intro_wrapper = document.querySelector('#introWrap');
  const intro_bg = document.querySelector('#introBg');
  const intro0_bg_container = document.querySelector('.intro0__bg-container');
  const scroll_indicator = document.querySelector('#scrollDownIndicator');
  const intro_skip_threshold = 0.35; // スクロールでイントロをスキップする閾値
  let skip_started = false;
  const tl_start = gsap.timeline({});
  const tl_repeat = gsap.timeline({
    repeat: -1,
    repeatDelay: 0.6,
    delay: 0.3,
  });

  // カスタムイージング
  CustomEase.create(
    'scrollIndicator',
    'M0,0 C0.204,0.05 0.379,0.152 0.44,0.3 0.521,0.499 0.48,0.673 0.642,0.856 0.751,0.981 0.91,1 1,1 '
    // 'M0,0 C0.204,0.05 0.338,0.154 0.4,0.3 0.437,0.389 0.481,0.657 0.642,0.84 0.751,0.965 0.91,1 1,1 '
    // 'M0,0 C0.288,0.052 0.34,0.124 0.391,0.241 0.43,0.331 0.481,0.657 0.642,0.84 0.751,0.965 0.91,1 1,1 '
  );

  let total_scroll = 0;
  tl_start
    .to(scroll_indicator, {
      scaleY: 1,
      duration: 1.0,
      ease: 'scrollIndicator',
    })
    .pause();

  tl_repeat
    .set(scroll_indicator, {
      '--scroll-down-origin': 'center top',
    })
    .to(scroll_indicator, {
      '--scroll-down-indicator': 1,
      duration: 0.7,
      // ease: 'power2.inOut',
      ease: 'scrollIndicator',
    })
    .set(scroll_indicator, {
      '--scroll-down-origin': 'center bottom',
    })
    .to(
      scroll_indicator,
      {
        '--scroll-down-indicator': 0,
        duration: 0.7,
        // ease: 'power2.inOut',
        ease: 'scrollIndicator',
      },
      '>+=0'
      // '>+=0.3'
    )
    .pause();

  function startScrollIndicator() {
    tl_start.play();
    tl_repeat.play();
  }
  setTimeout(startScrollIndicator, 3000);

  function moveIntroWrapper() {
    if (total_scroll < window.innerHeight * intro_skip_threshold && !skip_started) {
      gsap.to(intro_wrapper, {
        '--intro-scroll-y': `${total_scroll * -1}px`,
        '--intro-total-scroll': total_scroll,
        duration: 0.6,
        ease: 'power3.out',
      });
      if (!intro_bg.classList.contains('start-removing')) {
        gsap.to(intro_bg, {
          opacity: 1 - total_scroll / window.innerHeight,
          duration: 0.6,
        });
      }
      if (intro0_bg_container != null) {
        gsap.to(intro0_bg_container, {
          scale: 1 + (total_scroll / window.innerHeight) * 0.33,
          duration: 0.6,
          ease: 'power3.out',
        });
      }
    } else if (!skip_started) {
      skip_started = true;
      gsap.to(intro_wrapper, {
        '--intro-scroll-y': `${window.innerHeight * -0.75}px`,
        '--intro-total-scroll': 1,
        duration: 0.6,
        ease: 'power1.inOut',
      });
      skipIntro();
    }
  }

  // スクロールでイントロをスキップ
  document.addEventListener('wheel', (e) => {
    total_scroll = Math.max(0, total_scroll + e.deltaY * 0.25);
    moveIntroWrapper();
  });

  // タッチイベントをスクロール量に変換
  let touch_start = null;
  document.addEventListener('touchstart', (e) => {
    touch_start = e.touches[0].clientY;
  });
  document.addEventListener('touchmove', (e) => {
    if (touch_start != null) {
      const touch_end = e.touches[0].clientY;
      total_scroll = Math.max(0, total_scroll + (touch_start - touch_end) * 1);
      moveIntroWrapper();
      touch_start = touch_end;
    }
  });
  document.addEventListener('touchend', (e) => {
    if (touch_start != null) {
      moveIntroWrapper();
      touch_start = null;
    }
  });

  intro_wrapper.hideScrollIndicator = function () {
    tl_repeat.kill();
    const tl_hide = gsap.timeline();
    tl_hide
      .set(scroll_indicator, {
        '--scroll-down-origin': 'center bottom',
      })
      .to(scroll_indicator, {
        scaleY: 0,
        duration: 0.6,
        ease: 'power2.inOut',
      });
  };
}

function removeIntroBg() {
  const intro_bg = document.querySelector('#introBg');
  if (intro_bg && !intro_bg.classList.contains('start-removing')) {
    intro_bg.classList.add('start-removing');
    const tl = gsap.timeline({
      onComplete: () => {
        console.log('remove intro bg');
        intro_bg.remove();
      },
    });
    tl.to(intro_bg, {
      opacity: 0,
      duration: 0.6,
      ease: 'power2.inOut',
    });
  }
}

if (!intro_flag()) {
  skipIntro();
} else {
  async function intro() {
    await app.init({
      resizeTo: window,
      backgroundColor: 0x000000,
      // backgroundColor: 0xffffff
      zIndex: true,
    });
    container.appendChild(app.canvas);
    let zIndex = 1;
    PIXI.Assets.addBundle('intro', intro_assets);
    const assets = await PIXI.Assets.loadBundle('intro');

    function scene0() {
      let mql_portrait = window.matchMedia('(max-aspect-ratio: 2/3)');

      const logo = document.querySelector('#logoIntro');

      const path_a = logo.querySelector('#pathA');
      const path_b = logo.querySelector('#pathB');

      const path_a_length = path_a.getTotalLength();
      const path_b_length = path_b.getTotalLength();

      const bg = document.querySelector('.intro0__bg');

      const btn_start = document.querySelector('#btnIntroStart');
      const btn_skip = document.querySelector('#btnIntroSkip');

      path_a.style.strokeDashoffset = path_a_length * -1;
      path_a.style.strokeDasharray = `${path_a_length} ${path_a_length}`;

      path_b.style.strokeDashoffset = path_b_length * -1;
      path_b.style.strokeDasharray = `${path_b_length} ${path_b_length}`;

      function logoOut(callback, loopback = false) {
        // gsap.killTweensOf(bg);
        gsap.killTweensOf(logo);
        const wrapper = document.querySelector('#intro0');
        const tl_out = gsap.timeline();
        wrapper.style.pointerEvents = 'none';
        tl_out
          .to(
            bg,
            {
              opacity: 0,
              scale: 1.05,
              duration: 1,
            },
            0
          )
          .to(
            logo,
            {
              opacity: 0,
              y: () => {
                return -20;
              },
              duration: 1,
              ease: 'power1.inOut',
              onComplete: () => {
                if (typeof callback == 'function') {
                  requestAnimationFrame(callback);
                }
                if (!loopback && wrapper != null) {
                  wrapper.remove();
                }
                return;
              },
            },
            0
          );
        timeline_collector.push(tl_out);
        mql_portrait.removeEventListener('change', retryScene0);
      }

      const tl = gsap.timeline();
      tl.set(bg, {
        opacity: 0,
      })
        .set(path_a, {
          y: () => {
            return 50;
          },
        })
        .set(path_b, {
          y: () => {
            return 50;
          },
        });
      if (bg.tagName == 'video') {
        tl.to(bg, {
          opacity: 1,
          duration: 8,
        });
      } else {
        tl.to(bg, {
          opacity: 1,
          ease: 'none',
        }).fromTo(
          bg,
          {
            scale: 1.2,
          },
          {
            scale: 1.0,
            duration: 20,
            ease: 'ease.out',
          },
          '<'
        );
      }

      tl.to(
        logo,
        {
          opacity: 1,
          duration: 0.6,
        },
        0
      )
        .to(
          path_a,
          {
            strokeDashoffset: 0,
            duration: 3.6,
            ease: 'power1.inOut',
          },
          0
        )
        .to(
          path_b,
          {
            strokeDashoffset: 0,
            duration: 2.6,
            ease: 'power1.inOut',
          },
          1
        )
        .to(
          path_a,
          {
            y: 0,
            duration: 2,
            ease: 'power2.inOut',
          },
          2.2
        )
        .to(
          path_b,
          {
            y: 0,
            duration: 2.2,
            ease: 'power2.inOut',
          },
          2.2
        )
        .fromTo(
          '.introLogo__text',
          {
            opacity: 0,
            y: () => {
              return 10;
            },
          },
          {
            opacity: 1,
            y: 0,
            ease: 'power1.inOut',
            duration: 1.6,
            stagger: 0.2,
          },
          3
        )
        .fromTo(
          '.intro0__btns',
          {
            opacity: 0,
            y: () => {
              return 20;
            },
          },
          {
            opacity: 1,
            y: 0,
            duration: 2,
            ease: 'power2.inOut',
          },
          2.8
        )
        .pause();
      timeline_collector.push(tl);
      // メディアクエリが切り替わったらすぐやり直し
      function retryScene0() {
        tl.kill();
        gsap.killTweensOf(bg);
        gsap.killTweensOf(logo);
        gsap.killTweensOf(path_a);
        gsap.killTweensOf(path_b);
        gsap.killTweensOf('.introLogo__text');
        mql_portrait.removeEventListener('change', retryScene0);
        scene0();
      }
      mql_portrait.addEventListener('change', retryScene0, {
        once: true,
      });

      if (bg.tagName == 'VIDEO') {
        // 動画の場合
        bg.addEventListener('canplay', () => {
          bg.play();
          tl.play();
        });
        bg.src = bg.dataset.src;
        bg.load();
      } else {
        // 画像の場合
        tl.play();
        bg.removeAttribute('hidden');
      }

      // ボタン
      if (btn_start != null) {
        btn_start.addEventListener(
          'click',
          () => {
            logoOut(playIntro);
            gsap.to(btn_start, {
              opacity: 0,
              scale: 1,
            });
            gsap.to(btn_skip, {
              opacity: 0,
              scale: 0.95,
            });
          },
          { once: true }
        );
      }

      if (btn_skip != null) {
        btn_skip.addEventListener(
          'click',
          () => {
            logoOut();
            removeIntro();
            gsap.to(btn_skip, {
              opacity: 0,
              scale: 1,
            });
            gsap.to(btn_start, {
              opacity: 0,
              scale: 0.95,
            });
          },
          { once: true }
        );
      }
    }

    function indicatorBar() {
      const progress = this.time() / this.duration();
      let clippath = 'inset(0 0% 0 0%)';
      let offset = 0.12;
      if (progress <= offset) {
        const mini_progress = Power3.easeInOut(progress / offset);
        clippath = `inset(0 ${100 * (1 - mini_progress)}% 0 0%)`;
      } else if (progress >= 1 - offset) {
        const mini_progress = Power3.easeInOut((progress - (1 - offset)) / offset);
        clippath = `inset(0 0% 0 ${100 * mini_progress}%)`;
      }
      gsap.set('.introIndicator__bar', {
        '--progress': progress,
        clipPath: clippath,
      });
    }

    function oneScene(key, _duration = 6, callback = null) {
      const scene = {};
      const wink_default = 1.6 * 3;

      // アセットを取得
      let tex = assets[key];
      let sprite = PIXI.Sprite.from(tex);
      sprite.zIndex = zIndex++;

      // 戻り値を設定
      scene.texture = tex;

      function adjustSize() {
        if (app.stage && sprite) {
          sprite.anchor.set(0.5);
          const sizes = getFitContainer(sprite, app.screen);
          sprite.width = sizes.width;
          sprite.height = sizes.height;
          sprite.x = sizes.x;
          sprite.y = sizes.y;
        } else {
          window.removeEventListener('resize', adjustSize);
        }
      }

      window.addEventListener('resize', adjustSize);
      adjustSize();

      // 戻り値を設定
      scene.adjust = adjustSize;

      tex.source.resource.playsinline = true;
      // tex.source.resource.loop = true;
      sprite.alpha = 0;

      app.stage.addChild(sprite);

      // const pos = 0.45 / (sprite._texture.width / sprite._texture.height);
      const pos = (0.4 + 0.1 * Math.random()) / (sprite._texture.width / sprite._texture.height);
      const blur = new PIXI.filters.TiltShiftFilter({
        blur: 0,
        gradientBlur: 0,
        startY: app.stage.height * pos,
        endY: app.stage.height * pos,
      });

      const color = new PIXI.filters.AdjustmentFilter({
        alpha: 0,
        brightness: 2,
        // ganma: 2,
        // saturation: 0,
      });

      sprite.filters = [blur, color];

      function adjustBlurPosition() {
        if (app && app.stage) {
          blur.startY = app.stage.height * pos;
          blur.endY = app.stage.height * pos;
        } else {
          window.removeEventListener('resize', adjustBlurPosition);
        }
      }
      window.addEventListener('resize', adjustBlurPosition);

      const total_duration = Math.min(
        _duration,
        tex.source.resource.tagName != null && tex.source.resource.tagName == 'VIDEO'
          ? tex.source.resource.duration
          : _duration
      );
      const wink_duration = Math.min(wink_default, total_duration * 0.4);
      const start_fadeout_timing = total_duration - wink_duration;
      const tl = gsap.timeline({
        onUpdate: indicatorBar,
      });

      // 戻り値を設定
      scene.duration = total_duration;

      tl.set(
        sprite,
        {
          alpha: 1,
        },
        0
      )
        // 開く動き
        .fromTo(
          blur,
          {
            gradientBlur: 0,
            blur: 80,
          },
          {
            gradientBlur: 800,
            blur: 40,
            ease: 'power1.in',
            duration: wink_duration,
          },
          0
        )
        .fromTo(
          color,
          {
            alpha: 0,
            // brightness: 1,
            // ganma: 1,
          },
          {
            alpha: 1,
            // brightness: 1,
            // ganma: 1,
            ease: 'power1',
            duration: wink_duration,
          },
          0
        )
        // ズームする動き
        .to(
          sprite,
          {
            width: () => {
              const sizes = getFitContainer(sprite, app.screen, 1.1);
              return sizes.width;
            },
            height: () => {
              const sizes = getFitContainer(sprite, app.screen, 1.1);
              return sizes.height;
            },
            ease: 'none',
            duration: wink_duration + start_fadeout_timing,
          },
          0
        )
        .fromTo(
          blur,
          {
            gradientBlur: 800,
            blur: 40,
          },
          {
            gradientBlur: 0,
            blur: 80,
            ease: 'power1.out',
            duration: wink_duration,
          },
          start_fadeout_timing
        )
        .fromTo(
          color,
          {
            alpha: 1,
            brightness: 1,
            // ganma: 1,
          },
          {
            alpha: 0,
            brightness: 0.5,
            // ganma: 0.5,
            ease: 'none',
            duration: wink_duration,
            onComplete: () => {
              sprite.destroy();
              if (typeof callback == 'function') {
                callback();
              }
            },
          },
          start_fadeout_timing
        );
      timeline_collector.push(tl);
    }

    function setCaption(key) {
      const caption = intro_captions[key];
      // console.log(caption);

      const index = String(key + 1).padStart(2, '0');

      const container1 = document.querySelector('.introIndicator__date');
      const container2 = document.querySelector('.introIndicator__place');
      const container3 = document.querySelector('.introIndex .current');

      const date_span = document.createElement('span');
      const place_span = document.createElement('span');
      const index_span = document.createElement('span');
      const current_date_span = container1.querySelector('span');
      const current_place_span = container2.querySelector('span');
      const current_index_span = container3.querySelector('span');

      date_span.textContent = caption.date;
      place_span.textContent = caption.place;
      // date_span.textContent = 'date : ' + caption.date;
      // place_span.textContent = 'place : ' + caption.place;
      index_span.textContent = index;

      current_date_span.addEventListener('animationend', () => {
        current_date_span.remove();
      });
      current_place_span.addEventListener('animationend', () => {
        current_place_span.remove();
      });
      current_index_span.addEventListener('animationend', () => {
        current_index_span.remove();
      });

      container1.prepend(date_span);
      container2.prepend(place_span);
      container3.prepend(index_span);
    }

    const scene_duration = 8.5;

    function scene01() {
      oneScene('intro_src01', scene_duration);
      setCaption(0);
    }

    function scene02() {
      oneScene('intro_src02', scene_duration);
      setCaption(1);
    }

    function scene03() {
      oneScene('intro_src03', scene_duration);
      setCaption(2);
    }

    function scene04() {
      oneScene('intro_src04', scene_duration);
      setCaption(3);
    }

    function scene05() {
      oneScene('intro_src05', scene_duration);
      setCaption(4);
    }

    function scene06() {
      oneScene('intro_src06', scene_duration);
      setCaption(5);
    }

    function playIntro() {
      if (typeof window.playBGM == 'function') {
        window.playBGM();
      }

      // スクロールのインジケーターを隠す
      const intro_wrapper = document.querySelector('#introWrap');
      if (intro_wrapper != null && typeof intro_wrapper.hideScrollIndicator == 'function') {
        intro_wrapper.hideScrollIndicator();
      }

      let duration = scene_duration * 1000;
      // let duration = 15000;
      let overrap = 50;
      timeout_collector.push(setTimeout(scene01, 0));
      timeout_collector.push(setTimeout(scene02, duration * 1 - overrap * 1));
      timeout_collector.push(setTimeout(scene03, duration * 2 - overrap * 2));
      timeout_collector.push(setTimeout(scene04, duration * 3 - overrap * 3));
      timeout_collector.push(setTimeout(scene05, duration * 4 - overrap * 4));
      timeout_collector.push(setTimeout(scene06, duration * 5 - overrap * 5));
      timeout_collector.push(
        setTimeout(() => {
          showBrandStory();
        }, 4000)
      );

      gsap.fromTo(
        '.introIndicator',
        {
          opacity: 0,
          y: 10,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: 0.5,
          ease: 'power1.out',
        }
      );
      gsap.fromTo(
        '.introIndex',
        {
          opacity: 0,
          y: 10,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: 0.5,
          ease: 'power1.out',
        }
      );
      gsap.set('#introText', {
        opacity: 1,
      });
      document.querySelector('#introText').hidden = false;

      initFollower();
    }

    function endLogoType() {
      const tl = gsap.timeline();
      tl.set(
        '#introFinish svg',
        {
          opacity: 1,
        },
        0
      )
        .to(
          '.introIndicator',
          {
            opacity: 0,
            y: -10,
            duration: 1,
            delay: 0.5,
            ease: 'power1.out',
          },
          0
        )
        .to(
          '.introIndex',
          {
            opacity: 0,
            y: -10,
            duration: 1,
            delay: 0.5,
            ease: 'power1.out',
          },
          0.1
        )
        .fromTo(
          app.renderer.background,
          {
            color: '#000000',
          },
          {
            color: '#ffffff',
            duration: 2,
          },
          0
        )
        .to(
          '#introWrap',
          {
            backgroundColor: '#ffffff',
            duration: 1,
          },
          0
        )
        .fromTo(
          '#introFinish svg .logoType__line',
          {
            y: 5,
            opacity: 0,
            filter: 'blur(2px)',
          },
          {
            y: 0,
            opacity: 1,
            filter: 'blur(0px)',
            stagger: 0.2,
            duration: 1,
            ease: 'power1.out',
          },
          2
        )
        .to(
          '#introFinish svg .logoType__line',
          {
            y: -5,
            opacity: 0,
            filter: 'blur(2px)',
            stagger: 0.2,
            duration: 1,
            ease: 'power1.in',
          },
          6
        );
    }

    function endIntro() {
      const paragraphs = document.querySelectorAll('#introText .paragraph');
      paragraphs.forEach((paragraph, index) => {
        hideLetters(paragraph, 1, 0.8, index * 0.5);
      });
      timeout_collector.push(setTimeout(endLogoType, 1000));
      timeout_collector.push(setTimeout(removeIntro, 10000));

      // スキップボタンを非表示に
      document.querySelector('#introSkipButton').hide();
    }

    function showBrandStory() {
      const container = document.querySelector('#introText');
      const paragraphs = container.querySelectorAll('.paragraph');
      const interval = 2000;
      const speed = 1.1;
      const overlap = 0.89;
      let total_duration = 0;
      let index = 0;
      let move_total = 0;
      function showNextParagraph() {
        const paragraph = paragraphs[index++];
        move_total -= paragraph.offsetHeight;
        if (index < paragraphs.length) {
          const wait = showLetters(paragraph, speed, overlap);
          total_duration += wait;
          timeout_collector.push(setTimeout(showNextParagraph, wait * 1000 + interval));
        } else {
          // END
          const wait = showLetters(paragraph, speed, overlap, () => {
            timeout_collector.push(setTimeout(endIntro, 1600));
          });
          total_duration += wait;
          // console.log('イントロ：', total_duration);
        }
      }
      showNextParagraph();
    }

    function initFollower() {
      const intro_wrapper = document.querySelector('#introWrap');
      const follower = document.querySelector('#introSkipButton');
      let xTo = gsap.quickTo(follower, 'x', { duration: 0.4, ease: 'power3.out' }),
        yTo = gsap.quickTo(follower, 'y', { duration: 0.4, ease: 'power3.out' });
      let xSet = gsap.quickTo(follower, 'x', { duration: 0.05, ease: 'power3.out' }),
        ySet = gsap.quickTo(follower, 'y', { duration: 0.05, ease: 'power3.out' });
      let mm = gsap.matchMedia();
      let disabled = false;
      function hideFollower() {
        follower.classList.remove('is-active');
      }
      function showFollower() {
        follower.classList.add('is-active');
      }
      mm.add('(any-pointer: fine)', () => {
        const wait_to_rehide = 3000; // X秒無操作で隠す
        const offset_x = 15;
        const offset_y = 15;
        let timer;
        function move(e) {
          if (!disabled) {
            if (follower.classList.contains('is-active')) {
              if (timer != null) {
                clearTimeout(timer);
              }
              const wrapper_scroll =
                intro_wrapper.style.getPropertyValue('--intro-total-scroll') != ''
                  ? parseInt(intro_wrapper.style.getPropertyValue('--intro-total-scroll'))
                  : 0;

              xTo(e.clientX - offset_x);
              yTo(e.clientY - offset_y + wrapper_scroll);
              timer = setTimeout(hideFollower, wait_to_rehide);
            } else {
              xSet(e.clientX - offset_x);
              ySet(e.clientY - offset_y);
              timeout_collector.push(setTimeout(showFollower, 100));
            }
          }
        }
        window.addEventListener('mousemove', move);
        window.addEventListener('click', move);
        follower.addEventListener(
          'click',
          () => {
            window.removeEventListener('mousemove', move);
            window.removeEventListener('click', move);

            skipIntro();
            hideFollower();
          },
          {
            once: true,
          }
        );
      });
      mm.add('(any-pointer: coarse)', () => {
        const offset = 40;
        function toggleFollowerTouch(e) {
          if (!disabled) {
            if (!e.target.closest('#introSkipButton')) {
              if (!follower.classList.contains('is-active')) {
                if (e.touches != null) {
                  xSet(e.touches[0].clientX);
                  ySet(e.touches[0].clientY - offset);
                } else {
                  xSet(e.clientX);
                  ySet(e.clientY);
                }
                showFollower();
              } else {
                hideFollower();
              }
            } else {
              window.removeEventListener('touchstart', toggleFollowerTouch);
              skipIntro();
              hideFollower();
            }
          }
        }
        window.addEventListener('touchstart', toggleFollowerTouch);
      });

      follower.hide = () => {
        disabled = true;
        hideFollower();
      };
    }

    document.querySelector('body').classList.add('fixed');

    scene0();
    // endLogoType();
    // playIntro();
    // endIntro();
  }
  document.addEventListener('DOMContentLoaded', () => {
    intro();
    setTimeout(() => {
      introScroll();
    }, 1000);
  });
}
